var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{class:{ アイコンボタン: true, disabled: _vm.disabled },on:{"click":function($event){return _vm.doClick()}}},[_c('img',{attrs:{"src":_vm.icon()}}),_c('br'),_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }